const { NODE_ENV } = process.env;
const { origin, pathname } = window.location;
export const isDev = NODE_ENV === 'development';
export const baseURL = NODE_ENV === 'development' ? '/hosp/' : origin + pathname;
// export const baseURL = NODE_ENV === 'development' ? '/' : origin + pathname;
export const scope = 'zktr-hccm';
export const appName = 'sdc-hccm-hosp';
export const clientPrefix = '/hospital';
export const sendCodeTimeKey = '1';

export const socketURL =
  NODE_ENV === 'development'
    ? 'ws://dev.sdc.sinohealth.cn:30200/webSocket'
    : `ws://${window.location.hostname}:30200/webSocket`;
export const getTokenParams = {
  clientId: 'healthplus-oms',
  clientSecret: 'healthplus-oms',
  scope: 'zmn-rx-oms-server',
};
export const loginRememberKey = 'zk-hccm-w'; // 记住密码时保存数据的key
export default {
  baseURL,
  getTokenParams,
};

type ThemeData = {
  borderRadius?: number;
  colorPrimary: string;
};

// 主题色配置
export const currThemeData: any = {
  colorPrimary: '#217BA0',
  screenXLMax: 1799,
  screenXXL: 1800,
  screenXXLMin: 1800,
};
